export default "__VITE_ASSET__Bhz3qA65__"